import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'delete-modal-dialog',
    templateUrl: 'delete-modal-dialog.component.html',
    standalone: false
})

export class DeleteModalDialogComponent {

  public accept: boolean = false;
  public text: string;

  constructor(public dialogRef: MatDialogRef<DeleteModalDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any)
  {
      this.text = this.data.text;
  }

  public closeDialog() {
      this.dialogRef.close();
  }

  public save() {
    this.accept = true;
    this.closeDialog();
  }
}
